import React, { useEffect, useState } from "react";
import { TextField, Button, makeStyles } from "@material-ui/core";
import styles from "./ExtendCoolingPeriod.module.scss";
import saveCoolingPeriodExtension from "../../../api/Siteplan/saveCoolingPeriodExtension.api";

const ExtendCoolingPeriod = ({ extendInfo, closeModalHandler }) => {
  const [formData, setFormData] = useState({
    coolingPeriodExtensionDay: 10,
  });

  const useStyles = makeStyles(() => ({
    root: {
      minWidth: "30em",
      maxWidth: "30em",
      marginTop: "10px",
      marginBottom: "10px",
      backgroundColor: "#fff",
      position: "relative",
    },
  }));
  const classes = useStyles();

  useEffect(() => {
    if (extendInfo?.coolingPeriodExtensionDay) {
      setFormData({
        coolingPeriodExtensionDay: extendInfo.coolingPeriodExtensionDay,
      });
    }
  }, [extendInfo]);

  const handleSubmit = (e) => {
    e.preventDefault();
    saveCoolingPeriodExtension(
      extendInfo.clientId,
      formData.coolingPeriodExtensionDay
    );
    closeModalHandler();
  };

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className={styles.extend_cooling_period}>
      <form className={styles.extend_cooling_form} onSubmit={handleSubmit}>
        <TextField
          className={classes.root}
          label="Cooling period duration (days)"
          type="number"
          variant="outlined"
          name="coolingPeriodExtensionDay"
          value={formData?.coolingPeriodExtensionDay}
          onChange={onChange}
          min={10}
          inputProps={{ min: "10" }}
        />
        <Button
          variant="contained"
          type="submit"
          color="primary"
          className={styles.update_btn}
        >
          Update
        </Button>
      </form>
    </div>
  );
};

export default ExtendCoolingPeriod;
